module.exports = __webpack_public_path__ + "img/081-bermuda.78d64209.svg";